import React, { useState } from 'react';
import { Modal, Upload } from 'antd';
import { useAddToThrottleExemptions } from '../../../../mutation/mail';

const { Dragger } = Upload;

export default function AddToExemptionsModal({ isVisible, onClose }) {
  const [file, setFile] = useState(null);
  const { isLoading, mutateAsync } = useAddToThrottleExemptions();
  return (
    <Modal
      closable={!isLoading}
      maskClosable={!isLoading}
      okButtonProps={{
        disabled: !file || isLoading,
        loading: isLoading,
      }}
      title="Add emails to be exempted from throttling"
      visible={isVisible}
      width={800}
      onCancel={onClose}
      onOk={() =>
        mutateAsync(file)
          .then(() => setFile(null))
          .finally(onClose)
      }
    >
      <Dragger
        accept="text/csv"
        beforeUpload={uploadedFile => {
          setFile(uploadedFile);
          return false;
        }}
        fileList={file ? [file] : []}
        multiple={false}
        onRemove={() => setFile(null)}
      >
        <p className="ant-upload-text">Upload your CSV file here</p>
        <p className="ant-upload-hint">
          Emails in the list would never be throttled
        </p>
      </Dragger>
    </Modal>
  );
}
